// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Styles */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: var(--sidebar-width);
  background: white;
  border-right: 1px solid #e9ecef;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  transition: all 0.3s ease;
  z-index: 1000;
  overflow-y: auto;
}

.sidebar.collapsed {
  width: var(--sidebar-collapsed-width);
}

.sidebar-logo {
  font-size: 1.5rem !important;
}

.sidebar-header {
  height: var(--header-height);
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
}

.sidebar-brand {
  transition: opacity 0.3s ease;
}

.sidebar.collapsed .sidebar-brand {
  opacity: 0;
  visibility: hidden;
}

.nav-item {
  margin: 0.125rem 0.75rem;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  color: #6c757d;
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;
}

.nav-link:hover {
  background-color: #f8f9fa;
  color: #495057;
}

.nav-link.active {
  background-color: #e3f2fd;
  color: #1976d2;
  border-right: 4px solid #1976d2;
}

.nav-link i {
  width: 20px;
  height: 20px;
  margin-right: 0.75rem;
  flex-shrink: 0;
  transition: margin 0.3s ease;
}

.sidebar.collapsed .nav-link i {
  margin-right: 0;
}

.nav-text {
  transition: opacity 0.3s ease;
  white-space: nowrap;
}

.sidebar.collapsed .nav-text {
  opacity: 0;
  visibility: hidden;
}

.sidebar-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #e9ecef;
  padding: 1rem;
}

.user-info {
  transition: opacity 0.3s ease;
}

.sidebar.collapsed .user-info {
  opacity: 0;
  visibility: hidden;
}

/* Main Content */
.main-content {
  margin-left: var(--sidebar-width);
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  padding: 2rem;
}

.main-content.expanded {
  margin-left: var(--sidebar-collapsed-width);
}

/* Mobile Styles */
.mobile-header {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--header-height);
  background: white;
  border-bottom: 1px solid #e9ecef;
  z-index: 1001;
}

.mobile-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

@media (max-width: 767.98px) {
  .mobile-header {
    display: flex;
  }
  .sidebar {
    transform: translateX(-100%);
    padding-top: var(--header-height);
  }
  .sidebar.show {
    transform: translateX(0);
  }
  .main-content {
    margin-left: 0;
    padding-top: calc(var(--header-height) + 2rem);
  }
  .main-content.expanded {
    margin-left: 0;
  }
  .mobile-overlay.show {
    display: block;
  }
}
/* Custom Card Styles */
.stat-card {
  border: none;
  border-radius: 0.75rem;
  transition: transform 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.icon-wrapper {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.toggle-btn {
  border: none;
  background: transparent;
  padding: 0.5rem;
  border-radius: 0.5rem;
  transition: background-color 0.2s ease;
}

.toggle-btn:hover {
  background-color: #f8f9fa;
}`, "",{"version":3,"sources":["webpack://./src/components/back-office/sidebar/sidebar.scss"],"names":[],"mappings":"AAEA,mBAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,+BAAA;EACA,mDAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AADF;;AAIA;EACE,qCAAA;AADF;;AAIA;EACE,4BAAA;AADF;;AAIA;EACE,4BAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,UAAA;EACA,kBAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;AADF;;AAIA;EACE,yBAAA;EACA,cAAA;AADF;;AAIA;EACE,yBAAA;EACA,cAAA;EACA,+BAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,4BAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,6BAAA;EACA,mBAAA;AADF;;AAIA;EACE,UAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;EACA,aAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,UAAA;EACA,kBAAA;AADF;;AAIA,iBAAA;AACA;EACE,iCAAA;EACA,iCAAA;EACA,iBAAA;EACA,aAAA;AADF;;AAIA;EACE,2CAAA;AADF;;AAIA,kBAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,4BAAA;EACA,iBAAA;EACA,gCAAA;EACA,aAAA;AADF;;AAIA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;AADF;;AAIA;EACE;IACE,aAAA;EADF;EAIA;IACE,4BAAA;IACA,iCAAA;EAFF;EAKA;IACE,wBAAA;EAHF;EAMA;IACE,cAAA;IACA,8CAAA;EAJF;EAOA;IACE,cAAA;EALF;EAQA;IACE,cAAA;EANF;AACF;AASA,uBAAA;AACA;EACE,YAAA;EACA,sBAAA;EACA,+BAAA;AAPF;;AAUA;EACE,2BAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,sCAAA;AAPF;;AAUA;EACE,yBAAA;AAPF","sourcesContent":["@import '../../../styles/variables.scss';\n\n/* Sidebar Styles */\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: var(--sidebar-width);\n  background: white;\n  border-right: 1px solid #e9ecef;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  transition: all 0.3s ease;\n  z-index: 1000;\n  overflow-y: auto;\n}\n\n.sidebar.collapsed {\n  width: var(--sidebar-collapsed-width);\n}\n\n.sidebar-logo {\n  font-size: 1.5rem !important;\n}\n\n.sidebar-header {\n  height: var(--header-height);\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1rem;\n}\n\n.sidebar-brand {\n  transition: opacity 0.3s ease;\n}\n\n.sidebar.collapsed .sidebar-brand {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.nav-item {\n  margin: 0.125rem 0.75rem;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n  color: #6c757d;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.nav-link:hover {\n  background-color: #f8f9fa;\n  color: #495057;\n}\n\n.nav-link.active {\n  background-color: #e3f2fd;\n  color: #1976d2;\n  border-right: 4px solid #1976d2;\n}\n\n.nav-link i {\n  width: 20px;\n  height: 20px;\n  margin-right: 0.75rem;\n  flex-shrink: 0;\n  transition: margin 0.3s ease;\n}\n\n.sidebar.collapsed .nav-link i {\n  margin-right: 0;\n}\n\n.nav-text {\n  transition: opacity 0.3s ease;\n  white-space: nowrap;\n}\n\n.sidebar.collapsed .nav-text {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.sidebar-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid #e9ecef;\n  padding: 1rem;\n}\n\n.user-info {\n  transition: opacity 0.3s ease;\n}\n\n.sidebar.collapsed .user-info {\n  opacity: 0;\n  visibility: hidden;\n}\n\n/* Main Content */\n.main-content {\n  margin-left: var(--sidebar-width);\n  transition: margin-left 0.3s ease;\n  min-height: 100vh;\n  padding: 2rem;\n}\n\n.main-content.expanded {\n  margin-left: var(--sidebar-collapsed-width);\n}\n\n/* Mobile Styles */\n.mobile-header {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: var(--header-height);\n  background: white;\n  border-bottom: 1px solid #e9ecef;\n  z-index: 1001;\n}\n\n.mobile-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n@media (max-width: 767.98px) {\n  .mobile-header {\n    display: flex;\n  }\n\n  .sidebar {\n    transform: translateX(-100%);\n    padding-top: var(--header-height);\n  }\n\n  .sidebar.show {\n    transform: translateX(0);\n  }\n\n  .main-content {\n    margin-left: 0;\n    padding-top: calc(var(--header-height) + 2rem);\n  }\n\n  .main-content.expanded {\n    margin-left: 0;\n  }\n\n  .mobile-overlay.show {\n    display: block;\n  }\n}\n\n/* Custom Card Styles */\n.stat-card {\n  border: none;\n  border-radius: 0.75rem;\n  transition: transform 0.2s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n}\n\n.icon-wrapper {\n  width: 4rem;\n  height: 4rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1rem;\n}\n\n.toggle-btn {\n  border: none;\n  background: transparent;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  transition: background-color 0.2s ease;\n}\n\n.toggle-btn:hover {\n  background-color: #f8f9fa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
